
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 24a.5.5 0 01-.354-.146l-23-23A.5.5 0 01.853.146l23 23A.5.5 0 0123.5 24z"}}),_c('path',{attrs:{"d":"M.5 24a.5.5 0 01-.354-.854l23-23a.5.5 0 01.707.708l-23 23A.5.5 0 01.5 24z"}})])
          )
        }
      }
    